var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultiCheckbox',{attrs:{"label":_vm.scope.label,"checked":_vm.checked,"indeterminate":_vm.indeterminate,"disabled":_vm.required,"no-label":_vm.noLabel},on:{"change":function($event){return _vm.updateScope($event.target.checked)}}})}
var staticRenderFns = []

export { render, staticRenderFns }